
// Copyright (c) 2021. Sendanor <info@sendanor.fi>. All rights reserved.

export enum AppRoute {

    FORM_VALUE_VIEW        = "/edit/forms/:id/entries/:entryId",
    FORM_VALUE_LIST_VIEW   = "/edit/forms/:id/entries",

    FORM_VIEW        = "/edit/forms/:id",
    FORM_LIST_VIEW   = "/edit/forms",

    PIPELINE_RUN_VIEW        = "/edit/pipelines/:id/runs/:runId",
    PIPELINE_RUN_LIST_VIEW   = "/edit/pipelines/:id/runs",

    PIPELINE_VIEW        = "/edit/pipelines/:id",
    PIPELINE_LIST_VIEW   = "/edit/pipelines",

    AGENT_VIEW        = "/edit/agents/:id",
    AGENT_LIST_VIEW   = "/edit/agents",

    PUBLIC_FORM_VIEW = "/forms/:id",

    I_FORM          = "/iform",
    BUILDER         = "/builder",
    INDEX           = "/"

}

export const getAppRoute_FORM_VALUE_VIEW      = (id: string, entryId: string) => `/edit/forms/${q(id)}/entries/${q(entryId)}`;
export const getAppRoute_FORM_VALUE_LIST_VIEW = (id: string)                  => `/edit/forms/${q(id)}/entries`;
export const getAppRoute_FORM_VIEW            = (id: string)                  => `/edit/forms/${q(id)}`;
export const getAppRoute_PUBLIC_FORM_VIEW     = (id: string)                  => `/forms/${q(id)}`;

export const getAppRoute_PIPELINE_VIEW            = (id: string)              => `/edit/pipelines/${q(id)}`;
export const getAppRoute_PIPELINE_RUN_LIST_VIEW   = (id: string)              => `/edit/pipelines/${q(id)}/runs`;
export const getAppRoute_PIPELINE_RUN_VIEW   = (id: string, runId: string)              => `/edit/pipelines/${q(id)}/runs/${q(runId)}`;

export const getAppRoute_AGENT_VIEW            = (id: string)              => `/edit/agents/${q(id)}`;

const q = (value: string) => encodeURIComponent(value);

export default AppRoute;

